<script>
import { mapActions, mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters("notification", ["notificationText", "open"]),
	},
	methods: {
		...mapActions("notification", ["closeNotification"]),
		closeSnackbar() {
			this.closeNotification();
		}
	}
};
</script>

<template>
	<v-snackbar
		:value="open"
		@input="closeNotification"
		color="success"
		timeout="3000"
		bottom
	>
		{{ notificationText }}
		<template v-slot:action="{ attrs }">
			<v-btn
				text
				v-bind="attrs"
				@click="closeSnackbar"
			>
				Close
			</v-btn>
		</template>
	</v-snackbar>
</template>


// WEBPACK FOOTER //
// src/components/elements/Notification.vue